import {useScopeQuery} from '@/core/store/scopeQuery'
import {defineStore} from 'pinia'
import {computed, ref} from 'vue'
import {YandexMetricGoal} from "@/gql";

const STORE_NAME = 'yandex-metrika'

export type MetricGoalCode = 'registration-lk' | 'vhod-lk' | 'zakaz-on' | 'promo-lk'

export const useYandexMetrikaStore = defineStore(STORE_NAME, () => {
    const goals = ref<YandexMetricGoal[]>([])

    const {registerScopeQuery} = useScopeQuery()

    // Загружаем все цели метрики
    /*
    registerScopeQuery(STORE_NAME, 'app', {
        yandex_metric_goal_list: {
            __fragment: 'YandexMetrikGoalFields'
        }
    }, (data) => {
        goals.value = data.yandex_metric_goal_list || []
    })

     */

    // Получить цель по CODE
    const getGoalByCode = (code: string) => {
        return goals.value.find(goal => goal.CODE === code)
    }

    // Триггер цели по CODE
    const triggerGoal = (code: MetricGoalCode): void => {
        console.log('triggerGoal', code)

        if (typeof window === 'undefined' || typeof window.ym === "undefined")
            return;

        window.ym(14534278, 'reachGoal', code)
        console.log('reachedGoal', code)

        /*
        const goal = getGoalByCode(code)
        if (!goal && typeof goal !== 'undefined') {
          console.warn(`[Yandex.Metrika] Goal with code "${code}" not found`)
          return
        }
        */
    }

    return {
        goals: computed(() => goals.value),
        getGoalByCode,
        triggerGoal,
    }
})

// Типы для window
declare global {
    interface Window {
        ym?: (counterId: number, action: string, goalId: string, params?: any) => void
        YM_COUNTER_ID?: number
    }
}
